<div *ngIf="showSchoolSearch && currentUrl !== '/school-setup'" fxLayout="row" fxLayoutAlign="end center">
  <mat-form-field fxFlex="200" class="uhc-block" [formGroup]="searchSchoolForm">
    <mat-label>{{getSearchLabel()}}</mat-label>
    <input matInput name="client" [matAutocomplete]="clientAutocomplete"
       formControlName="client" (change)="clientControlChange()">
    <mat-autocomplete autoActiveFirstOption #clientAutocomplete="matAutocomplete" [displayWith]="displayFn"
      (closed)="closed()">
      <mat-option *ngFor="let client of filteredClients | async" [value]="client"
         (onSelectionChange)="updateForm($event)">
        {{client.Name}} {{client.Number ? ' (' + client.Number + ')' : ''}}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
</div>
